import { FC, useState } from "react"
import { Alert } from "@mui/material"

interface TelegramMediaContentProps {
  url: string
  type: "photo" | "video" | "animation"
}

/**
 * Renders a media URL as the appropriate HTML element.
 * photo  → <img>
 * video  → <video controls>
 * animation → <video autoPlay loop muted> (GIF-style)
 *
 * Shows a warning Alert on load error.
 */
export const TelegramMediaContent: FC<TelegramMediaContentProps> = ({
  url,
  type,
}) => {
  const [error, setError] = useState(false)

  if (!url) return null

  if (error) {
    return (
      <Alert severity="warning" sx={{ mb: 1 }}>
        Не удалось загрузить медиа
      </Alert>
    )
  }

  if (type === "photo") {
    return (
      <img
        src={url}
        alt="media"
        className="tg-bubble-media"
        onError={() => setError(true)}
      />
    )
  }

  if (type === "video") {
    return (
      <video
        src={url}
        controls
        className="tg-bubble-media"
        onError={() => setError(true)}
      />
    )
  }

  // animation
  return (
    <video
      src={url}
      autoPlay
      loop
      muted
      playsInline
      className="tg-bubble-media"
      onError={() => setError(true)}
    />
  )
}
